import { create } from 'zustand'
import type { DrawMode, DrawnGeometry } from '../types/geo'

interface GeometryState {
  drawnGeometry: DrawnGeometry | null
  interactionMode: DrawMode
  isDrawing: boolean
  isModalOpen: boolean

  setDrawnGeometry: (geom: DrawnGeometry | null) => void
  setInteractionMode: (mode: DrawMode) => void
  setIsDrawing: (drawing: boolean) => void
  openModal: () => void
  closeModal: () => void
  clearGeometry: () => void
}

export const useGeometryStore = create<GeometryState>((set) => ({
  drawnGeometry: null,
  interactionMode: 'none',
  isDrawing: false,
  isModalOpen: false,

  setDrawnGeometry: (drawnGeometry) => set({ drawnGeometry }),
  setInteractionMode: (interactionMode) => set({ interactionMode }),
  setIsDrawing: (isDrawing) => set({ isDrawing }),
  openModal: () => set({ isModalOpen: true }),
  closeModal: () => set({ isModalOpen: false }),
  clearGeometry: () =>
    set({ drawnGeometry: null, interactionMode: 'none', isDrawing: false, isModalOpen: false }),
}))
